export const isPointInText = (canvasRef, point, textItem) => {
  const canvas = canvasRef.current;
  const ctx = canvas.getContext('2d');
  ctx.font = `${textItem.fontSize}px ${textItem.fontFamily}`;
  const textMetrics = ctx.measureText(textItem.text);
  const textWidth = textMetrics.width;
  const textHeight = textItem.fontSize;

  return (
    point.x >= textItem.x &&
    point.x <= textItem.x + textWidth &&
    point.y >= textItem.y - textHeight &&
    point.y <= textItem.y
  );
};
